import React from 'react';
import UsTodniKamgarStore from '../stores/UsTodniKamgarStore';
var axios = require('axios');
var constants = require("../constants/constants");

export default class BlaclkListKamgarShow extends React.Component {
    constructor(props) {
        super(props);
        let CompanyId = localStorage.getItem('CompanyId') || 1;
        this.state = {
            iskamgarDetails: false,
            isKamgarInfo: false,
            isEditAction: false,
            KamgarInformation: [],
            workerInfo: [],
            editKamgarData: null,
            CompanyId: CompanyId,
        };
        this.getKamgarRecord = this.getKamgarRecord.bind(this);
    }
    
    BlakListInformation() {
        var user = JSON.parse(sessionStorage.getItem("User"));
        let currentComponent = this;
        axios.get(constants.config.HOST + constants.api.GET_BLACKLISTED_KAMKAR_DETAILS, {
            //  params: { CompanyId: user.TargetCompanyId, YearId: user.TargetYearId}
            params: { TransportersId: user.TransportersId, CompanyId: localStorage.getItem('CompanyId') || 1, YearId: user.TargetYearId }

        }).then(function (response) {
            currentComponent.setState({ workerInfo: response.data })
            //  console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        });
    }

    getKamgarRecord() {
        this.BlakListInformation();
    }

    componentWillMount() {
        this.BlakListInformation();
        UsTodniKamgarStore.addListener('KamgarRecord', this.getKamgarRecord);
    }

    componentWillUnmount() {
        UsTodniKamgarStore.removeListener('KamgarRecord', this.getKamgarRecord)
    }
    //Button method
    kamgarDetails(e) {
        this.setState({
            iskamgarDetails: true
        });
        this.props.history.push('/UsTodKamgaranchiMahiti')
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    render() {
        return (
            <div className="pages">
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <h3 style={{ 'color': '#0000FF' }}><b style={{ 'padding-left': '50px' }}>ब्लाकलिस्ट बदल  माहिती </b></h3>
                            <div>
                                {
                                    (this.state.workerInfo !== null || this.state.workerInfo !== undefined) ?
                                        this.state.workerInfo.map(function (worker, index) {
                                            return (
                                                <tr>
                                                    <div style={{ padding: '13px 20px 20px 13px' }} className="card ">
                                                        <h4>  <b style={{ 'color': '#FF0000' }}> कामगाराचे   नाव : <b style={{ 'color': '#FF0000' }}> {worker.fullname}</b></b>    </h4>
                                                        <button type="button" className="btn btn-info btn pull-right " onClick={() => this.searchBlackListed(worker.AdharCardNo)}>Search</button>
                                                    </div>
                                                </tr>
                                            )
                                        })
                                        : ''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/BlaclkListKamgarShow.jsx